import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  maxRating?: number;
}

function StarRating({ rating, onRatingChange, maxRating = 5 }: StarRatingProps) {
  const handleStarClick = (starValue: number) => {
    // Always set to the clicked star value (1-index based)
    onRatingChange(starValue);
  };

  return (
    <div className="flex items-center gap-0.5" role="radiogroup" aria-label="Word rating">
      {Array.from({ length: maxRating }, (_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= rating;

        return (
          <button
            key={starValue}
            type="button"
            onClick={() => handleStarClick(starValue)}
            className={cn(
              "p-0.5 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 rounded",
              isFilled
                ? "text-yellow-500"
                : "text-muted-foreground"
            )}
            aria-label={`Rate ${starValue} star${starValue !== 1 ? 's' : ''}`}
            aria-pressed={isFilled}
          >
            <Star
              className={cn(
                "h-4 w-4 transition-all",
                isFilled && "fill-current"
              )}
            />
          </button>
        );
      })}
    </div>
  );
}

export default StarRating;
